import { client } from '@atlassian/rovo-content-bridge-api/client-types';

const AVP_DASHBOARD_CLIENT_ID_PREFIX = 'avp-dashboard';

export const getAvpDashboardClientId = (dashboardAri: string) =>
	client(`${AVP_DASHBOARD_CLIENT_ID_PREFIX}-${dashboardAri}`);
